export const countryConfigBG = {
  home: {
    skeleton: {
      banner: true,
      bubbles: false,
      featuredProducts: true,
      services: true,
      starredProductLists: 0,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  },
  'landing-courier': {
    bikeCollection: 'za-velosipedi-i-skuteri',
    carCollection: 'za-vodachi-na-avtomobili'
  }
};
